import React from 'react';
import PropTypes from 'prop-types';
import ButtonWrapper from '../Button/ButtonWrapper';
import DefaultButton from '../Button/DefaultButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FormattedMessage } from 'react-intl';

const DialogModal = ({
  isModalOpen,
  editable,
  confirmAction,
  cancelAction,
  dialogTitle,
  confirmBtnTitle,
  cancelBtnTitle,
  children }) => {
  return (
    <div>
      <Dialog
        open={isModalOpen}
        onClose={cancelAction}
      >
        {dialogTitle &&
          <DialogTitle style={{ padding: '30px 45px' }}>
            <FormattedMessage id={dialogTitle} />
          </DialogTitle>
        }

        {children}

        {confirmAction && cancelAction &&
        <DialogActions style={{ padding: '0 30px 30px 0' }}>
          <ButtonWrapper>
            <DefaultButton
              primary={false}
              disabled={!editable}
              title={cancelBtnTitle}
              onClick={cancelAction}
            />
            <DefaultButton
              primary={true}
              disabled={!editable}
              title={confirmBtnTitle}
              onClick={confirmAction}
            />
          </ButtonWrapper>
        </DialogActions>}
      </Dialog>
    </div>
  );
};

DialogModal.propTypes = {
  isModalOpen: PropTypes.bool,
  editable: PropTypes.bool,
  confirmAction: PropTypes.func,
  cancelAction: PropTypes.func,
  dialogTitle: PropTypes.string,
  confirmBtnTitle: PropTypes.string,
  cancelBtnTitle: PropTypes.string,
};

export default DialogModal;
